import { render, staticRenderFns } from "./MessagingDrawer.vue?vue&type=template&id=9af18480"
import script from "./MessagingDrawer.vue?vue&type=script&lang=js"
export * from "./MessagingDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports